import { useEffect, useState } from 'react';

const format = (timeZone, date) =>
  new Intl.DateTimeFormat('en-GB', { timeZone, hour: '2-digit', minute: '2-digit', hour12: false }).format(date);

// Current wall-clock time in a time zone ("14:32"), refreshed every 15s
export const useClock = timeZone => {
  const [time, setTime] = useState(() => format(timeZone, new Date()));

  useEffect(() => {
    const id = setInterval(() => setTime(format(timeZone, new Date())), 15000);
    return () => clearInterval(id);
  }, [timeZone]);

  return time;
};
